// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Color} from './color.js'
import {PaperFlair} from './paper-flair.js'

export class Paper {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Paper {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPaper(bb: flatbuffers.ByteBuffer, obj?: Paper): Paper {
    return (obj || new Paper()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPaper(bb: flatbuffers.ByteBuffer, obj?: Paper): Paper {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new Paper()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  flair(): PaperFlair | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  flairSpacing(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  flairBleeds(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  flairCentered(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  backgroundColor(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  legacyPaperIndex(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null
  }

  static startPaper(builder: flatbuffers.Builder) {
    builder.startObject(6)
  }

  static addFlair(builder: flatbuffers.Builder, flair: PaperFlair) {
    builder.addFieldInt8(0, flair, null)
  }

  static addFlairSpacing(builder: flatbuffers.Builder, flairSpacing: number) {
    builder.addFieldFloat32(1, flairSpacing, null)
  }

  static addFlairBleeds(builder: flatbuffers.Builder, flairBleeds: boolean) {
    builder.addFieldInt8(2, +flairBleeds, null)
  }

  static addFlairCentered(builder: flatbuffers.Builder, flairCentered: boolean) {
    builder.addFieldInt8(3, +flairCentered, null)
  }

  static addBackgroundColor(builder: flatbuffers.Builder, backgroundColorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(4, backgroundColorOffset, 0)
  }

  static addLegacyPaperIndex(builder: flatbuffers.Builder, legacyPaperIndex: number) {
    builder.addFieldInt8(5, legacyPaperIndex, null)
  }

  static endPaper(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
